import { Divider } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import {
  LoadingWorkloadText,
  UserWorkloadWrapper,
  WorkloadLoaderContainer,
} from "../AdvanceSearchList.style";
import PatientStatusCounts from "./PatientStatusCounts";
import ServiceStatusCounts from "./ServiceStatusCounts";
import { IUserInfo, IWorkloadCounts } from "@home-health-notify/domain";
import {
  IOrganizationContext,
  OrganizationContext,
  useTranslation,
} from "hhn-commons";
import CircularProgress from "@mui/material/CircularProgress";

type UserWorkloadProps = {
  userInfo: IUserInfo;
  loadUserWorkload?: boolean;
};

export const UserWorkload = ({
  userInfo,
  loadUserWorkload = false,
}: UserWorkloadProps) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "advanceSearch" });
  const { selectedOrgUser }: IOrganizationContext =
    useContext(OrganizationContext);

  const [workloadCounts, setWorkloadCounts] = useState<IWorkloadCounts>();

  const fetchUserWorkloadDetails = async () => {
    const workloadData =
      await selectedOrgUser?.userDirectory.fetchUserWorkloadDetails(
        userInfo.id,
      );
    workloadData && setWorkloadCounts(workloadData);
  };

  useEffect(() => {
    loadUserWorkload && !workloadCounts && fetchUserWorkloadDetails();
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [loadUserWorkload]);

  return !workloadCounts ? (
    <WorkloadLoaderContainer data-testid="user-workload-loader">
      <CircularProgress size={20} />
      <LoadingWorkloadText>{tNs("loadingWorkloadDetails")}</LoadingWorkloadText>
    </WorkloadLoaderContainer>
  ) : (
    <UserWorkloadWrapper data-testid="user-workload">
      <PatientStatusCounts
        userId={userInfo.id}
        workloadCounts={workloadCounts}
      />
      <Divider />
      <ServiceStatusCounts
        userId={userInfo.id}
        workloadCounts={workloadCounts}
      />
    </UserWorkloadWrapper>
  );
};
